<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title
        class="heading-title"
        v-if="this.elm != 3 && this.e1 == 1"
      >
        Enrol Users
      </v-toolbar-title>
      <v-toolbar-title class="heading-title" v-else>
        Enrol Groups
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <div id="slideout-container">
      <v-stepper v-model="e1" class="no-transition" alt-labels non-linear>
        <v-stepper-header v-if="this.elm != 3">
          <v-stepper-step :complete="e1 > 1" step="1"
            >Select Users</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" v-if="this.e1 == 2" step="2"
            >Select Groups</v-stepper-step
          >
          <v-stepper-step
            :complete="e1 > 2"
            style="text-align: center"
            v-else
            step="2"
            >Click Groups to enrol any groups</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-header v-if="this.elm == 3">
          <v-stepper-step :complete="e1 > 3" step="1"
            >Set Deadline</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="max-height-list scroll-y">
            <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
              <!-- Unassigned Users  -->
              <div class="filterSection">
              <v-text-field
                v-model="userSearch"
                label="Filter Users By Name Or Email"
                type="text"
                @change="applyUserSearch"
                class="filter-user"
                append-icon="fa-search"
              ></v-text-field>
              <v-select v-if="this.locations.length"
                :items="locations"
                :clearable="true"
                item-text="name"
                item-value="id"
                :placeholder="$globalConfig.APP_NAME === 'senso' ? 'Select Sites' : 'Select Locations'"
                multiple
                small-chips
                class="categories"
                @change="filterUsersByLocations($event)"
                attach
              >
              <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
            </v-select>
              </div>
              <v-expansion-panels accordion v-model="panel2" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="grey50"
                    class="assigned-user-heading assigned-user-heading2"
                    >Users NOT enrolled</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <!-- <div class="enrol_all_checkbox">
                                            <v-checkbox v-model="enrol_all" label="Select to enrol all users"></v-checkbox>
                                        </div> -->
                    <v-skeleton-loader v-if="userLoading2 && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="userLoading2 && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>                    
                    <v-data-table
                      v-model="unAssignedUsers"
                      :headers="computedHeaders"
                      :options.sync="userOptions2"
                      :server-items-length="serverUser2ItemsLength"
                      v-show="!userLoading2"
                      :items="users2"
                      item-key="id"
                      show-select
                      class="enrol-user-list-tbl"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
                      }"
                      v-if="!enrol_all"
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <!-- <h4 v-if="allUsersEnrolled">All users have been enrolled</h4> -->
            <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
              <v-expansion-panels accordion v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="grey50"
                    class="assigned-user-heading assigned-user-heading2"
                    >Enrolled users
                    <!-- <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                              <v-btn
                                              v-on="on"
                                              class="ml-1"
                                              outlined
                                              x-small
                                              color="$improve-grey-900"
                                              style="width:auto;"
                                              >
                                                  <v-icon x-small>fa fa-question</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Below you will see all enrolled Users. To un-enrol Users please select them by ticking the<br> box next to their name or use the select all function to select everyone on this page. <br>Complete the process to un-enrol Users before trying to enrol more Users.</span>
                                        </v-tooltip> -->
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="userLoading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="userLoading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>                    
                    <v-data-table
                      v-model="selectedUsers"
                      :headers="computedHeaders"
                      :options.sync="userOptions"
                      :server-items-length="serverUserItemsLength"
                      v-show="!userLoading"
                      :items="users"
                      item-key="id"
                      class="enrol-user-list-tbl"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
                      }"
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-stepper-content>
          <v-stepper-content step="2" class="max-height-list scroll-y">
            <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
              <v-text-field
                v-model="groupSearch"
                label="Filter Groups By Name"
                type="text"
                @change="applyGroupSearch"
                append-icon="fa-search"
                class="filter-user"
              ></v-text-field>
              <v-expansion-panels accordion v-model="panel2" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="grey50"
                    class="assigned-user-heading assigned-user-heading2"
                    >Groups NOT enrolled</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="groupLoading2 && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="groupLoading2 && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>                    
                    <v-data-table
                      v-model="selectedGroups2"
                      :headers="groupHeaders"
                      :options.sync="groupOptions2"
                      :server-items-length="serverGroupItemsLength2"
                      v-show="!groupLoading2"
                      :items="groups2"
                      item-key="id"
                      show-select
                      class="mb-5 enrol-user-list-tbl"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15],
                      }"
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <!-- <h4 v-if="allGroupsEnrolled">All groups have been enrolled</h4> -->
            <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
              <v-expansion-panels accordion v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="grey50"
                    class="assigned-user-heading assigned-user-heading2"
                    >Groups enrolled</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="groupLoading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="groupLoading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>                    
                    <v-data-table
                      v-model="selectedGroups"
                      :headers="groupHeaders"
                      :options.sync="groupOptions"
                      :server-items-length="serverGroupItemsLength"
                      v-show="!groupLoading"
                      :items="groups"
                      item-key="id"
                      class="mb-5 enrol-user-list-tbl"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15],
                      }"
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-stepper-content>
          <v-stepper-content step="3" class="max-height-list">
            <date-picker :color="datePickerColor"></date-picker>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-footer absolute>
      <v-flex class="pa-4" text-right>
        <div v-if="e1 == 1" class="sm-space-between fit-btn-underscreen">
          <v-btn color="grey300" class="cancel-button fix-btn-padding" @click="closePanel"
            >Cancel</v-btn
          >
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn
            v-else
            color="primary"
            class="add-course-button fix-btn-padding"
            :disabled="unAssignedUsers.length < 1"
            @click="enrolUsers"
            >Enrol Users</v-btn
          >
          <v-btn
            v-if="!loading"
            color="primary"
            class="add-course-button fix-btn-padding"
            @click="e1 = 2"
            >GROUPS</v-btn
          >
        </div>
        <div v-if="e1 == 2" >
          <v-btn v-if="!loading" color="grey300" class="mr-4 " @click="e1 = 1"
            >Back</v-btn
          >
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn
            v-else
            color="primary"
            class="add-course-button"
            :disabled="unAssignedUsers.length < 1 && selectedGroups2.length < 1"
            @click="enrolUsers"
            >Enrol</v-btn
          >
        </div>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';
import userAPI from '@/api/user.js';
import groupAPI from '@/api/group.js';
import DatePicker from '@/components/admin/global/Datepicker';
export default {
  name: 'UserDetails',
  components: {
    DatePicker,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    params: {
      type: String,
      default: '',
    },
    elm: {
      type: Number,
      default: 1,
    },
    name: {
      type: String,
      default: '',
    },
    locations: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      userHeaders: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
      ],
      groupHeaders: [
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
      ],
      panel: [0, 1],
      panel2: [0, 1],
      loading: false,
      e1: this.elm,
      selectedUsers: [],
      selectedGroups: [],
      userSearch: '',
      groupSearch: '',
      users: [],
      groups: [],
      userSearchParams: '',
      groupSearchParams: '',
      groupUnEnrolledSearchParams: '',
      userOptions: {},
      groupOptions: {},
      groupOptions2: {},
      userLoading: false,
      groupLoading: false,
      userPagination: {},
      groupPagination: {},
      selectedDate: 'Not Set',
      deadlineSet: false,
      successMessage: 'Users Successfully Enrolled.',
      successMessageDeadline: 'Deadline Successfully Set.',
      errorMessage: 'Oops, something went wrong!',
      nothingSelected: "You haven't selected any Users or Groups.",
      deadlineNotSet: "You haven't set a Deadline.",
      allUsersEnrolled: false,
      allGroupsEnrolled: false,
      userLoading2: false,
      userPagination2: {},
      users2: [],
      unAssignedUsers: [],
      groups2: [],
      groupPagination2: {},
      groupLoading2: false,
      selectedGroups2: [],
      AllPreviousEnrolledUsers: [],
      AllPreviousEnrolledGroups: [],
      enrol_all: false,
      UnEnrollNotification:
        'Unenrolling user(s) or group(s) from this course will PERMANENTLY DELETE all their progress and completion data for all users. Are you sure you want to proceed?',
      successUnEnrollMessage:
        'User(s) or Group(s) are now unenrolled and all their progress has been deleted. ',
      userOptions2: {},
      userUnEnrolledSearchParams: '',
      filterLocations: '',
      debounceTimeout: null,
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.userHeaders];
      if (this.locations.length) {
        headers.splice(3, 0, { text: `${this.$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}`, value: 'location', sortable: false });
      }
      return headers;
    },
    serverUserItemsLength: function () {
      return this.userPagination.total;
    },
    userItemsPerPage: function () {
      return this.userPagination.per_page;
    },
    userPage: function () {
      return this.userPagination.current_page;
    },
    userParams: function () {
      return this.$gf.getQueryString(
        this.userOptions,
        this.serverUserItemsLength
      );
    },
    selectedUsersTotal: function () {
      return this.selectedUsers.length;
    },
    serverGroupItemsLength: function () {
      return this.groupPagination.total;
    },
    groupItemsPerPage: function () {
      return this.groupPagination.per_page;
    },
    groupPage: function () {
      return this.groupPagination.current_page;
    },
    groupParams: function () {
      return this.$gf.getQueryString(this.groupOptions);
    },
    groupUnEnrolledParams: function () {
      return this.$gf.getQueryString(this.groupOptions2);
    },
    selectedGroupsTotal: function () {
      return this.selectedGroups.length;
    },
    serverUser2ItemsLength: function () {
      return this.userPagination2.total;
    },
    serverGroupItemsLength2: function () {
      return this.groupPagination2.total;
    },
    userUnEnrolledParams: function () {
      return this.$gf.getQueryString(
        this.userOptions2,
        this.serverUser2ItemsLength
      );
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    datePickerColor() {
      return this.$gf.headerColor();
    },
  },
  watch: {
    userOptions: {
      handler() {
        this.getEnrolledUsers();
      },
      deep: true,
    },
    groupOptions: {
      handler() {
        this.getGroups();
        // this.getUnenrolledGroups();
      },
      deep: true,
    },
    groupOptions2: {
      handler() {
        // this.getGroups();
        this.getUnenrolledGroups();
      },
      deep: true,
    },
    userOptions2: {
      handler() {
        this.getUnenrolledUsers();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getEnrolledUsers() {
      this.userLoading = true;
      courseAPI
        .getCourseEnrolledIndividualUsers(this.id, this.userParams, this.userSearchParams)
        .then((resp) => {
          this.users = resp.data.data;
          this.AllPreviousEnrolledUsers = resp.data.data;
          this.userPagination = resp.data.meta.pagination;
          this.userLoading = false;
          //this.selectedUsers = resp.data.data;
        });
    },
    getUnenrolledUsers() {
      this.userLoading2 = true;
      courseAPI
        .getCourseUnenrolledUsers(
          this.id,
          this.userUnEnrolledParams,
          this.userUnEnrolledSearchParams
        )
        .then((resp) => {
          this.users2 = resp.data.data;
          this.userPagination2 = resp.data.meta.pagination;
          this.userLoading2 = false;
          this.users2.length == 0
            ? (this.allUsersEnrolled = true)
            : (this.allUsersEnrolled = false);
        });
    },
    getGroups() {
      this.groupLoading = true;
      let queryParams = this.groupParams + this.groupSearchParams;
      courseAPI.getCourseEnrolledGroups(this.id, queryParams).then((resp) => {
        this.groupLoading = false;
        this.groups = resp.data.data;
        this.groupPagination = resp.data.meta.pagination;
        //this.selectedGroups = resp.data.data;
        this.AllPreviousEnrolledGroups = resp.data.data;
        this.groups.length == 0
          ? (this.allGroupsEnrolled = true)
          : (this.allGroupsEnrolled = false);
      });
    },
    getUnenrolledGroups() {
      this.groupLoading2 = true;
      courseAPI
        .getCourseUnenrolledGroups(
          this.id,
          this.groupUnEnrolledParams,
          this.groupUnEnrolledSearchParams
        )
        .then((resp) => {
          this.groupLoading2 = false;
          this.groups2 = resp.data.data;
          this.groupPagination2 = resp.data.meta.pagination;
        });
    },
    applyUserSearch() {
      this.createSearchParams();
    },
    applyGroupSearch() {
      if (this.groupSearch != '') {
        this.groupOptions.page = 1;
        this.groupOptions2.page = 1;
        this.groupSearchParams = '&search=name:' + this.groupSearch;
        this.groupUnEnrolledSearchParams = '&search=name:' + this.groupSearch;
        this.getGroups();
        this.getUnenrolledGroups();
      } else {
        this.groupOptions.page = 1;
        this.groupOptions2.page = 1;
        this.groupSearchParams = '';
        this.groupUnEnrolledSearchParams = '';
        this.getGroups();
        this.getUnenrolledGroups();
      }
    },
    processSelectedUsers() {
      let users = [];
      this.selectedUsers.forEach(function (x) {
        users.push(x.id);
      });
      return users;
    },
    processUnassignSelectedUsers() {
      let users = [];
      this.unAssignedUsers.forEach(function (x) {
        users.push(x.id);
      });
      return users;
    },
    processSelectedGroups() {
      let groups = [];
      this.selectedGroups.forEach(function (x) {
        groups.push(x.id);
      });
      return groups;
    },
    processUnassignSelectedGroups() {
      let groups = [];
      this.selectedGroups2.forEach(function (x) {
        groups.push(x.id);
      });
      return groups;
    },
    processUnselectedUsers() {
      let removeUsers = [];
      let AllenrolledUsers = [];

      this.selectedUsers.forEach(function (x) {
        AllenrolledUsers.push(x.id);
      });

      this.AllPreviousEnrolledUsers.forEach(function (x) {
        if (!AllenrolledUsers.includes(x.id)) {
          removeUsers.push(x.id);
        }
      });
      return removeUsers;
    },
    processUnselectedGroups() {
      let removeGroups = [];
      let AllenrolledGroups = [];

      this.selectedGroups.forEach(function (x) {
        AllenrolledGroups.push(x.id);
      });

      this.AllPreviousEnrolledGroups.forEach(function (x) {
        if (!AllenrolledGroups.includes(x.id)) {
          removeGroups.push(x.id);
        }
      });

      return removeGroups;
    },
    process() {
      this.loading = true;
      courseAPI
        .enrolUsers(this.id, {
          // assign_users: this.processSelectedUsers(),
          unassign_users: this.processUnassignSelectedUsers(),
          // assign_groups: this.processSelectedGroups(),
          unassign_groups:
            this.e1 == 2 ? this.processUnassignSelectedGroups() : [],
          selectedDate: this.selectedDate,
          enrolAll: this.enrol_all,
        })
        .then(() => {
          //this.removeUsersAndGroups();
          EventBus.$emit('COURSES_UPDATED', this.params);
          this.closePanel();
          if (this.e1 == 1) {
            var successMessage =
              'You have enrolled ' +
              this.processUnassignSelectedUsers().length +
              ' user(s) on to ' +
              this.name;
          } else {
            var successMessage =
              'You have enrolled ' +
              this.processUnassignSelectedUsers().length +
              ' user(s) and ' +
              this.processUnassignSelectedGroups().length +
              ' group(s) on to ' +
              this.name;
          }
          this.$snotify.success(successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    removeUsersAndGroups() {
      courseAPI.removeUsersAndGroups(this.id, {
        users: this.processUnselectedUsers(),
        groups: this.processUnselectedGroups(),
      });
    },
    contine(toast) {
      this.$snotify.remove(toast.id);
      this.selectedDate = '';
      this.process();
    },
    setADate(toast) {
      this.$snotify.remove(toast.id);
      this.loading = false;
      this.el = 3;
    },
    enrolUsers() {
      // if(this.processUnassignSelectedUsers().length >= 1 || this.processUnassignSelectedGroups().length >= 1 ) {
      //     var enrollNotification = 'You are enrolling '+ this.processUnassignSelectedUsers().length + ' new users and ' + this.processUnassignSelectedGroups().length + ' new groups to "'+ this.name +'" course'
      //     this.$snotify.warning(enrollNotification);
      // }
      this.processEnrolUsers();
    },
    processEnrolUsers(toast = '') {
      this.loading = true;
      if (this.unAssignedUsers.length + this.selectedGroups2.length == 0) {
        this.$snotify.error(this.nothingSelected);
        this.loading = false;
      } else {
        this.process();
      }
    },
    setEventBus() {
      EventBus.$on('DATE_SELECTED', (date) => {
        this.deadlineSet = true;
        this.selectedDate = date;
      });
    },
    closePanel() {
      this.$emit('closePanel', {});
    },
    filterUsersByLocations(data){
      clearTimeout(this.debounceTimeout);
      this.filterLocations = data.toString();
      this.debounceTimeout = setTimeout(() => {
        this.createSearchParams();
      }, 1000);
    },
    createSearchParams() {
      this.userSearchParams = '';
      this.userUnEnrolledSearchParams = '';
      this.userOptions.page = 1;
      this.userOptions2.page = 1;
      if(this.userSearch){
        this.userSearchParams +=  '&search=first_name:' +
        this.userSearch + ';last_name:' + this.userSearch + ';email:' + this.userSearch;
        
        this.userUnEnrolledSearchParams +=  '&search=first_name:' +
        this.userSearch + ';last_name:' + this.userSearch + ';email:' + this.userSearch;
      }
        if (this.filterLocations) {
        this.userSearchParams += '&locations=' + this.filterLocations;

        this.userUnEnrolledSearchParams += '&locations=' + this.filterLocations;
      }
      this.getEnrolledUsers();
      this.getUnenrolledUsers();
    }
  },
};
</script>
<style media="screen">
#slideout-container {
  height: calc(100vh - 65px - 100px);
}
.max-height-list {
  height: calc(100vh - 65px - 100px - 48px);
}
.no-transition .stepper__content {
  transition: none;
}
.v-expansion-panel-header > :not(.v-expansion-panel-header__icon) {
  flex: none;
}
.snotify-confirm .snotifyToast__body {
  font-weight: 600 !important;
}
</style>
